import React from 'react';
import cx from 'classnames';
import { ModalPanel } from '@els/els-react--modal-panel';
import { FlexLayout } from '../../components/flex/FlexLayout.component';
import { FlexLayoutModifier } from '../../components/flex/flex.constants';
import { FlexItem } from '../../components/flex/FlexItem.component';
import {
  ActivityTypeConfigMap,
} from '../../models/remediation.models';
import { AssessmentGoalDto } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import { getGoalBreadcrumbs } from '../../utilities/remediation.utilities';

export type RemediationGoalModalProps = {
  children: React.ReactNode;
  handleCancelClick: () => void;
  assessmentGoal: AssessmentGoalDto;
}

const RemediationGoalModal = (props: RemediationGoalModalProps): JSX.Element => {

  const {
    assessmentGoal,
    children,
    handleCancelClick
  } = props;

  const goalBreadcrumbs = getGoalBreadcrumbs(assessmentGoal);

  return (
    <ModalPanel
      panelSize="large"
      panelRight
      modalProps={{
        onClose: () => {
          handleCancelClick();
        },
        className: `c-ssa-remediation-goal-modal-panel c-ssa-remediation-goal-modal-panel--${assessmentGoal.type.toLowerCase()}`,
      }}
    >
      <div>
        <div className={
          cx(
            'c-ssa-remediation-goal-modal',
            `c-ssa-remediation-goal-modal--${assessmentGoal.type.toLowerCase()}`
          )
        }>

          <div className="u-els-margin-bottom-1x1o2">

            <FlexLayout
              modifiers={[FlexLayoutModifier.TOP, FlexLayoutModifier.GUTTERS]}
            >
              <FlexItem modifiers={[FlexLayoutModifier.GROW]}>
                <h2><strong>{ActivityTypeConfigMap[assessmentGoal.type].title}</strong> / {goalBreadcrumbs.text}</h2>
              </FlexItem>
            </FlexLayout>

            <div className="u-els-margin-top c-els-divider" />
          </div>
          {children}
        </div>
      </div>
    </ModalPanel>
  );
};

export default RemediationGoalModal;
